
import { Component, Mixins } from "vue-property-decorator";
import { IComboOption, IComboSelectBehavior, Questionnaire, QuestionnaireOption, QuestionnaireType } from "../../../../../../documaker/domain/format/objects";
import {
  IQuestionnairePropertyEditable,
  instanceOfIQuestionnairePropertyEditable,
  instanceOfICheckBehaviorPropertyEditable,
  instanceOfITextPropertyEditable,
  instanceOfINamePropertyEditable,
  instanceOfIHisInformationKeyPropertyEditable,
  instanceOfIComboSelectBehaviorPropertyEditable,
  instanceOfICategoryNamePropertyEditable,
} from "../../../../../domain/editableFormat/properties";
import { IConfiguration } from "../../../../../domain/configuration";

@Component
export default class QuestionnairePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IQuestionnairePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IQuestionnairePropertyEditable) => T, defaultValue: T) => T;

  $configuration!: IConfiguration;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isQuestionnaireEditable(): boolean {
    return this.$configuration.formatEditor.extensions.questionnaire.isEnable
        && this.readPropertyOrDefault(s => instanceOfIQuestionnairePropertyEditable(s), false);
  }

  get questionnaire(): Questionnaire {
    return this.readPropertyOrDefault(s => {
      const value = Questionnaire.from(s.questionnaire().getValue());
      if (instanceOfICategoryNamePropertyEditable(s) && s.categoryName().isEditable()) {
        value.display = s.categoryName().getValue();
      }
      if (instanceOfIComboSelectBehaviorPropertyEditable(s) && s.comboSelectBehavior().isEditable()) {
        value.answerOption = this.toQuestionnaireOptions(s.comboSelectBehavior().getValue());
      }
      return value;
    }, new Questionnaire("", [], undefined, "", ""));
  }

  set questionnaire(value: Questionnaire) {
    this.writePropertyWhenValid(s => {
      s.questionnaire().setValue(Questionnaire.to(value));
      if (instanceOfINamePropertyEditable(s) && s.name().isEditable()) {
        s.name().setValue(value.text);
      }
      if (instanceOfIHisInformationKeyPropertyEditable(s) && s.hisInformationKey().isEditable()) {
        s.hisInformationKey().setValue(value.text);
      }
      if (["display", "group"].includes(value.type) && instanceOfITextPropertyEditable(s) && s.text().isEditable()) {
        s.text().setValue(value.text);
      }
      if (instanceOfICategoryNamePropertyEditable(s) && s.categoryName().isEditable()) {
        s.categoryName().setValue(value.display);
      }
      if (value.answerOption && instanceOfIComboSelectBehaviorPropertyEditable(s) && s.comboSelectBehavior().isEditable()) {
        s.comboSelectBehavior().setValue(this.toIComboSelectBehavior(value.answerOption));
      }
    });
  }

  private toQuestionnaireOptions(behavior: IComboSelectBehavior): QuestionnaireOption[] {
    return behavior.options.map(o => QuestionnaireOption.from({
      valueCoding: {
        display: o.text,
        code: o.code,
      }
    }));
  }

  private toIComboSelectBehavior(answerOption: QuestionnaireOption[]): IComboSelectBehavior {
    return {
      code: "",
      options: answerOption.map<IComboOption>(o => ({
        text: o.valueCoding.display,
        isSelected: false,
        score: null,
        style: {
          foreground: {
            color: {
              value: "#000000",
            }
          },
          background: {
            isEnable: false,
            color: {
              value: "#ffffff",
            }
          },
        },
        code: o.valueCoding.code,
        movePageBehavior: {
          pageKey: null,
          isEnable: false,
        },
      }))
    };
  }

  get selectableQuestionnaireTypes(): (QuestionnaireType | undefined)[] {
    return this.readPropertyOrDefault(s => s.selectableQuestionnaireTypes(), []);
  }

  get isQuestionnaireDisplayEditable(): boolean {
    // displayはチェックのみ編集可能とする.
    return this.readPropertyOrDefault(s => instanceOfICheckBehaviorPropertyEditable(s), false);
  }

  get isQuestionnaireCodeEditable(): boolean {
    // codeはチェックのみ編集可能とする.
    return this.readPropertyOrDefault(s => instanceOfICheckBehaviorPropertyEditable(s), false);
  }

  get isQuestionnaireAnswerEditable(): boolean {
    // answer系はリスト選択のみ編集可能とする.
    return this.readPropertyOrDefault(s => instanceOfIComboSelectBehaviorPropertyEditable(s), false);
  }
}
